import type { MetaFunction } from '@remix-run/node';
import type { Blog } from 'schema-dts';
import type { loader } from '~/routes/_app.articles';
import type { StaticParentLoaders } from '../util';
import { getMetaBaseUrl } from '../util/create-meta-base-url';

export const createBlogSchema: MetaFunction<
    typeof loader,
    StaticParentLoaders
> = (props) => {
    const { data } = props;
    if (!data) return [];
    const baseUrl = getMetaBaseUrl(props);

    const blogSchema: Blog = {
        '@type': 'Blog',
        description: data.localisation?.Description ?? '',
        image: data.common?.contentTop,
        name: "ArchiPro's Blog",
        url: baseUrl + props.location.pathname,
    };

    return [blogSchema];
};
